(function () {
  const root = document.querySelector('.clpdp-quote[data-quote-endpoint]');
  if (!root) return;

  const toggle = root.querySelector('.clpdp-quote__toggle');
  const panel = root.querySelector('.clpdp-quote__panel');
  const input = root.querySelector('.clpdp-quote__form input');
  const submit = root.querySelector('.clpdp-quote__submit');
  const status = root.querySelector('.clpdp-quote__status');
  const results = root.querySelector('.clpdp-quote__results');
  const productForm = root.closest('form');
  if (!toggle || !panel || !input || !submit || !status || !results || !productForm) return;

  let request = null;
  let sequence = 0;
  const money = new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' });
  const dateFormat = new Intl.DateTimeFormat('es-MX', {
    weekday: 'long', day: 'numeric', month: 'long', timeZone: 'UTC'
  });

  function dateLabel(value) {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(value || '')) return null;
    const date = new Date(value + 'T12:00:00Z');
    return Number.isNaN(date.getTime()) ? null : dateFormat.format(date);
  }

  function make(tag, className, content) {
    const element = document.createElement(tag);
    element.className = className;
    if (content != null) element.textContent = content;
    return element;
  }

  function currentVariant() {
    const selected = productForm.querySelector('[name="id"]');
    const urlVariant = new URLSearchParams(window.location.search).get('variant');
    return Number(selected && selected.value || urlVariant || root.dataset.defaultVariant);
  }

  function currentQuantity() {
    const field = productForm.querySelector('[name="quantity"]');
    return Number(field && field.value || 1);
  }

  function renderQuote(quote) {
    results.replaceChildren();
    const dispatch = dateLabel(quote.dispatchDate);
    results.append(make(
      'div', 'clpdp-quote__destination',
      quote.destination + ' · ' + (quote.dispatchToday ? 'Sale hoy si compras antes de las 3:00 p. m.' : 'Despacho estimado: ' + (dispatch || 'próximo día hábil'))
    ));
    quote.rates.forEach((rate) => {
      const row = make('div', 'clpdp-quote__rate');
      row.append(make('strong', '', rate.service));
      row.append(make('b', '', rate.amount === 0 ? 'Gratis' : money.format(rate.amount)));
      const arrival = dateLabel(rate.estimatedDeliveryDate);
      row.append(make('small', '', arrival ? 'Entrega estimada: ' + arrival : 'Fecha por confirmar al pagar'));
      results.append(row);
    });
    results.hidden = false;
  }

  async function quote() {
    const postalCode = input.value.trim();
    if (!/^\d{5}$/.test(postalCode)) {
      status.textContent = 'Ingresa un código postal de cinco dígitos.';
      results.hidden = true;
      input.focus();
      return;
    }
    const variantId = currentVariant();
    const quantity = currentQuantity();
    if (!Number.isSafeInteger(variantId) || !Number.isInteger(quantity) || quantity < 1 || quantity > 10) {
      status.textContent = 'Selecciona una presentación y una cantidad de hasta 10 piezas para cotizar.';
      results.hidden = true;
      return;
    }

    if (request) request.abort();
    const controller = new AbortController();
    request = controller;
    const thisRequest = ++sequence;
    const timeout = window.setTimeout(() => controller.abort(), 12000);
    const cancelWhenHidden = () => {
      if (document.visibilityState === 'hidden') controller.abort();
    };
    document.addEventListener('visibilitychange', cancelWhenHidden);
    submit.disabled = true;
    status.textContent = 'Consultando tarifas y fechas disponibles…';
    results.hidden = true;
    try {
      const response = await fetch(root.dataset.quoteEndpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'omit',
        body: JSON.stringify({ variantId, quantity, postalCode }),
        signal: controller.signal
      });
      const payload = await response.json();
      if (thisRequest !== sequence) return;
      if (!response.ok || !payload.ok || !Array.isArray(payload.quote && payload.quote.rates)) {
        throw new Error(payload.error || 'No pudimos confirmar el envío para este código postal.');
      }
      status.textContent = '';
      renderQuote(payload.quote);
    } catch (error) {
      if (thisRequest !== sequence) return;
      status.textContent = controller.signal.aborted
        ? 'La consulta tardó demasiado. Intenta de nuevo.'
        : (error.message || 'No pudimos cotizar ahora. Intenta de nuevo más tarde.');
    } finally {
      window.clearTimeout(timeout);
      document.removeEventListener('visibilitychange', cancelWhenHidden);
      if (thisRequest === sequence) {
        submit.disabled = false;
        request = null;
      }
    }
  }

  toggle.addEventListener('click', () => {
    const opening = panel.hidden;
    panel.hidden = !opening;
    toggle.setAttribute('aria-expanded', String(opening));
    if (opening) input.focus();
  });
  submit.addEventListener('click', quote);
  input.addEventListener('keydown', (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      quote();
    }
  });
})();
